<template>
    <div class="Instructions">
        <transition @enter="enter" @leave="leave">
            <div ref="container" class="Instructions__container">
                <img class="Instructions__logo" src="@/commons/images/meneath_titre_en.png" alt="meneath">
                <div class="Instructions__title">Meneath is an augmented reality experience.</div>
                <div class="Instructions__description">Scan the QR code with your phone to begin the experience.</div>
                
                <div class="Welcome__button" @click="onClick()" v-if="!ready">Start</div>

                <div class="Instructions__qrcode hidden">   
                    <div class="Instructions__canvas" id="canvas"></div>
                    <!-- <div class="Instructions__url">memeath-v2.dpt.media/media/{{ room }}</div>  -->
                </div> 

            </div>
        </transition>
    </div>
</template>

<script>

export default {
    name: 'Instructions',
    props: [ 'room' ],
    data: ()=>({
        ready: false,
    }),  
    beforeDestroy() {},
    created(){},
    mounted() {

        const qrCode = new QRCodeStyling({
            width: 300,
            height: 300,
            data: window.location.origin + "/media/"+ this.room,
            image: require('@/commons/images/onf.png'),
            dotsOptions: {
                color: "#5b9b45",
                type: "rounded"
            },
            backgroundOptions: {
                color: "#fff",
            },
            imageOptions: {
                crossOrigin: "anonymous",
                margin: 20
            }
        });

        qrCode.append(document.getElementById("canvas"))

    },

    methods: {
        enter(done) { done() },
        leave(done) { done() },
        onClick() {
            this.ready = true;
            document.querySelector(".Instructions__qrcode").classList.remove("hidden");
        },
    }
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.hidden {
    display: none !important; 
}

.Welcome__button {
    text-align: center;
    font-family: 'Ciutadella-Medium'
    font-size: 20px
    text-decoration: none;
    background-color: white;
    color: black;
    border-style: solid
    border-color: white
    padding: 12px 64px;
    display: inline-block;
    margin: 34px 2px;
    border-radius: 28px;
}

.Instructions
    position absolute
    width 100vw
    height 100vh
    top 0
    left 0
    z-index 1000
    display flex 
    align-items center
    justify-content center
    background-color: rgba(0 0 0 0.5);
    backdrop-filter: blur(10px);

    &__container 
        width 100%
        max-width 600px
        height 100%
        display flex 
        align-items center
        justify-content center
        flex-direction column
        text-align center

    &__logo
        margin-bottom: 48px

    &__title
        margin-bottom 18px
        font-size: 28px
        font-family: 'Ciutadella-Medium'

    &__description
        font-family: 'Ciutadella-Medium'
        font-size: 16px

    &__qrcode
        display flex
        flex-direction column
        align-items center
        margin-top 32px

    &__canvas 
        width 120px
        padding 8px 8px 3px
        background white
        border-radius 8px
        margin-bottom 12px

        & canvas 
            width 100%

    &__url 
        background violet
        padding 4px 10px

</style>